import React from 'react'
import { Box, TextField, InputAdornment, IconButton, Button } from '@mui/material'
import {
  Search as SearchIcon,
  Clear as ClearIcon,
  Tune as TuneIcon,
} from '@mui/icons-material'

export interface TableSearchBarProps {
  isMobile: boolean
  searchInput: string
  setSearchInput: (value: string) => void
  activeFilterCount?: number
  onOpenMobileFilters?: () => void
  placeholder?: string
  mobilePlaceholder?: string
}

export const TableSearchBar: React.FC<TableSearchBarProps> = ({
  isMobile,
  searchInput,
  setSearchInput,
  activeFilterCount = 0,
  onOpenMobileFilters,
  placeholder = 'Search...',
  mobilePlaceholder = 'Search...',
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        justifyContent: 'space-between',
      }}
    >
      <TextField
        size="small"
        placeholder={isMobile ? mobilePlaceholder : placeholder}
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" color="action" />
            </InputAdornment>
          ),
          endAdornment: searchInput ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={() => setSearchInput('')} aria-label="Clear search">
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        fullWidth
        sx={{ flex: 1, width: '100%' }}
      />

      {isMobile && onOpenMobileFilters && (
        <Button
          variant={activeFilterCount > 0 ? 'contained' : 'outlined'}
          size="small"
          onClick={onOpenMobileFilters}
          startIcon={<TuneIcon sx={{ fontSize: 18 }} />}
          sx={{
            height: 40,
            px: 1.75,
            minWidth: 'auto',
            flexShrink: 0,
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8125rem',
            borderRadius: 1,
            whiteSpace: 'nowrap',
          }}
        >
          {activeFilterCount > 0 ? `Filters (${activeFilterCount})` : 'Filters'}
        </Button>
      )}
    </Box>
  )
}

export default TableSearchBar
